import React from "react";
import { useLocation } from "react-router-dom";
import { useI18n } from "../../i18n/I18nContext";
import { useContent } from "../../hooks/useContent";
import { useSeo } from "../../components/SEO";
import PageHero from "../../components/PageHero";
import { Section } from "../../components/Primitives";
import { LEGAL } from "./legalContent";
import NotFound from "../NotFound";

export default function LegalPage() {
  const slug = useLocation().pathname.replace(/^\//, "");
  const { lang, pick } = useI18n();
  const doc = LEGAL[slug];
  const { data: inventory = [] } = useContent("cookie_inventory");
  const { data: policies = {} } = useContent("policies");
  useSeo(doc ? doc.title[lang] : "");

  if (!doc) return <NotFound />;

  return (
    <>
      <PageHero title={doc.title[lang]} subtitle={doc.intro[lang]} />
      <Section tone="surface">
        <div className="mx-auto max-w-3xl space-y-8" data-testid="legal-content">
          {doc.inventory && (
            <div>
              <h2 className="font-display text-2xl">{lang === "fr" ? "Témoins installés" : "Installed cookies"}</h2>
              <div className="mt-4 overflow-x-auto rounded-2xl border border-black/5">
                <table className="w-full text-left text-sm">
                  <thead className="bg-[#EEF1E9] uppercase tracking-wide text-[#5C6370]">
                    <tr>
                      <th className="p-3">{lang === "fr" ? "Nom" : "Name"}</th>
                      <th className="p-3">{lang === "fr" ? "Catégorie" : "Category"}</th>
                      <th className="p-3">{lang === "fr" ? "Finalité" : "Purpose"}</th>
                      <th className="p-3">{lang === "fr" ? "Durée" : "Duration"}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inventory.map((c) => (
                      <tr key={c.id} className="border-t border-black/5">
                        <td className="p-3 font-medium">{pick(c.name)}</td>
                        <td className="p-3">{c.category}</td>
                        <td className="p-3 text-[#5C6370]">{pick(c.purpose)}</td>
                        <td className="p-3">{pick(c.duration)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {doc.sections.map((s, i) => (
            <div key={i}>
              <h2 className="font-display text-2xl">{s.h[lang]}</h2>
              <p className="mt-2 text-[#5C6370]">{s.p[lang]}</p>
            </div>
          ))}
          {policies?.version && (
            <p className="text-sm text-[#5C6370]">
              {lang === "fr" ? "Version de la politique" : "Policy version"} : {policies.version}
              {policies.effective_date ? ` · ${policies.effective_date}` : ""}
            </p>
          )}
        </div>
      </Section>
    </>
  );
}
